import { ThemeProvider } from "@elit-hair/elit-ui";

import { useSettings } from "@/providers/general/settings-provider";

export function ThemeProviderWrapper({ children }: { children: React.ReactNode }) {
    const { currentSettings } = useSettings();

    return (
        <ThemeProvider initialTheme={currentSettings.THEME} initialColorScheme={currentSettings.COLOR_SCHEME}>
            {children}
        </ThemeProvider>
    );
}
